import {
    Popover as _Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverBody,
    PopoverFooter,
    PopoverArrow,
    PopoverCloseButton
} from '@chakra-ui/core';

export const Popover = { // eslint-disable-line import/prefer-default-export
    Container: _Popover,
    Trigger: PopoverTrigger,
    Content: PopoverContent,
    Header: PopoverHeader,
    Body: PopoverBody,
    Footer: PopoverFooter,
    Arrow: PopoverArrow,
    CloseButton: PopoverCloseButton
};
